// extracted by mini-css-extract-plugin
module.exports =  {"title":"_93444fe79c--title--upMu1"};